import { render, staticRenderFns } from "./tbkbdjs.vue?vue&type=template&id=fec66bc8&scoped=true"
import script from "./tbkbdjs.vue?vue&type=script&lang=js"
export * from "./tbkbdjs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fec66bc8",
  null
  
)

export default component.exports